module.exports = __webpack_public_path__ + "/static/assets/63e5827c1506216bd7c9927a4e5eb558.svg";